import fallbackImage from '@/assets/images/seo-fallback.png'

export const setMeta = (seo) => {
  const title = seo.title ? `${seo.title} | Ville éponge` : 'Ville éponge'

  document.title = title
  const metas = document.getElementsByTagName('meta')
  metas['keywords'].content =
    seo.keywords ||
    'Ville, éponge, nature, verdissement, citoyen, engagement, partenaires, formations, outils, projets'
  metas['og:title'].content = title
  metas['description'].content = seo.description || ''
  metas['og:description'].content = seo.description || ''
  metas['og:image'].content = seo.image?.original || fallbackImage
  metas['og:type'].content = seo.type || 'website'
  metas['og:url'].content = seo.url || import.meta.env.BASE_URL
}
